import { MonetaryAmount } from "../../../../../currency/currencyTypes"
import { IconDetails, PaymentMethodType } from "../../../../../payments/paymentTypes"

export enum WalletsOrderTypeRefill {
    "REFILL" = "REFILL",
    "REFILL_SUBSCRIPTION" = "REFILL_SUBSCRIPTION",
}

type RefillDetails = Readonly<{
    manual: {
        paymentMethods: Array<RefillPaymentMethods>
    }
    automatic?: {
        paymentMethods: Array<RefillPaymentMethods>
        subscription?: {
            order: {
                id: number
                uid: string
                orderType: string
                payment: {
                    method: PaymentMethodType
                }
                refillDetails: {
                    amount: MonetaryAmount
                    threshold: MonetaryAmount
                }
            }
        }
    }
}>

export type RefillPaymentMethods = Readonly<{
    value: PaymentMethodType
    showSalesConditions: boolean
    translationKey: string
    icon?: IconDetails
}>

export enum RefillAmount {
    "AMOUNT_100" = "100",
    "AMOUNT_300" = "300",
    "AMOUNT_500" = "500",
    "AMOUNT_OTHER" = "AMOUNT_OTHER",
}

export type UserWallet = Readonly<{
    id?: number
    uid?: string
    displayName: string
    statusLabel: string
    brandingLabel: string
    acquirer: {
        acquirerSetupId: number
    }
    paymentDetails: {
        refill: RefillDetails
    }
    balance: MonetaryAmount
}>

export type RefillFormValues = {
    paymentMethod: string
    amount: string
    customAmount: string
}

export type AutoRefillFormValues = RefillFormValues & {
    threshold: string
}
